import React from 'react'
import { Card, CardHeader, Button, CardTitle, CardSubtitle } from 'reactstrap'
import { Form, InputGroup } from 'react-bootstrap'

export default function ListTopBar({ 
	filterType, 
	setFilterType, 
	filterValue, 
	setFilterValue, 
	filterScope,
	setFilterScope,
	reload,
	title,
	subtitle,
	options,
	scopes,
	ctaText,
	handleCtaClick,
	className,
	prefix,
	onExport,
	secundaryCtaText,
	handleSecundaryCtaClick
}) {
	return (
		<React.Fragment>
			<Card className={className}>
				<CardHeader>
					{ options && (
						<div className="float-right">
							<InputGroup>
								{ prefix && (
									<InputGroup.Prepend>
										{prefix}
									</InputGroup.Prepend>
								)}
								<InputGroup.Prepend>
									<Form.Control 
										as="select" 
										className="bg-light"
										value={filterType}
										onChange={e => setFilterType(e.target.value)}
									>
										{options.map((option,i) => 
											<option key={i} value={option.value}>{option.label}</option>
										)}
									</Form.Control>
								</InputGroup.Prepend>
								<Form.Control 
									placeholder="Escriba aquí" 
									value={filterValue}
									onChange={e => setFilterValue(e.target.value)}
								/>
								<InputGroup.Append className="mb-1">
									<Button color={ctaText ? 'dark' : 'primary'} onClick={reload}>Buscar</Button>
								</InputGroup.Append>
								{ secundaryCtaText && (
									<Button className="ml-2 mb-1" color="primary" onClick={handleSecundaryCtaClick}>{secundaryCtaText}</Button>
								)}
								{ ctaText && (
									<Button className="ml-2 mb-1" color="primary" onClick={handleCtaClick}>{ctaText}</Button>
								)}
								{ onExport && (
									<Button className="ml-2 mb-1" color="primary" onClick={onExport}>Exportar</Button>
								)}
							</InputGroup>
							{ scopes && (
								<InputGroup>
									<Form.Control 
										disabled 
										value="Estado" 
										style={{ maxWidth:'70px' }} 
										className="bg-light"
									/>
									<Form.Control
										as="select"
										value={filterScope}
										onChange={e => {
											setFilterScope(e.target.value)
											reload()
										}}
									>
										<option value="">:: Ver todos los estados ::</option>
										{ scopes.map(scope => (
											<option key={scope.value} value={scope.value}>{scope.label}</option>
										)) }
									</Form.Control>
								</InputGroup>
							)}
						</div>
					)}
					<div>
						{ title && <CardTitle>{title}</CardTitle> }
						{ subtitle && <CardSubtitle>{subtitle}</CardSubtitle> }
					</div>
				</CardHeader>
			</Card>
		</React.Fragment>
	)
}